import React, { useState, useEffect } from 'react';
import "../../css/FAQ_New.css";
import { FAQ_Accordion as FaqDial } from './FAQ_Accordion';
import { motion, AnimatePresence } from 'framer-motion';
import { faq } from "../content/text";
import { FiCrosshair } from 'react-icons/fi';

export const FAQHome = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  // Auto-play logic
  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % 5);
    }, 4500); // Rotates every 4.5 seconds
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="faq_v24_wrapper" id="faq-section">
      
      {/* Deep Immersive Space */}
      <div className="faq_v24_bg"></div>

      {/* Header (Top Right) */}
      <div className="faq_v24_header">
        <motion.div 
            className="faq_v24_badge"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
        >
            <FiCrosshair /> KNOWLEDGE VAULT
        </motion.div>
        <motion.h2 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          Dial into <span className="faq_v24_gradient_text">Answers.</span>
        </motion.h2>
      </div>

      <div className="faq_v24_container">
        
        {/* The Massive Rotary Dial Area (Left Side) */}
        <div className="faq_v24_dial_area">
            <FaqDial activeIndex={activeIndex} setActiveIndex={setActiveIndex} limit={5} />
        </div>

        {/* The Detail Panel (Right Side) */}
        <div className="faq_v24_detail_area">
            <AnimatePresence mode="wait">
                <motion.div
                    key={activeIndex}
                    className="faq_v24_detail_panel"
                    initial={{ opacity: 0, x: 40, filter: "blur(10px)" }}
                    animate={{ opacity: 1, x: 0, filter: "blur(0px)" }}
                    exit={{ opacity: 0, x: -40, filter: "blur(10px)" }}
                    transition={{ duration: 0.5, ease: "easeOut" }}
                >
                    <div className="faq_v24_detail_num">0{activeIndex + 1}</div>
                    <h3>{faq[activeIndex]?.ques}</h3>
                    <div className="faq_v24_divider"></div>
                    <p>{faq[activeIndex]?.ans}</p>
                </motion.div>
            </AnimatePresence>
        </div>

      </div>

    </section>
  );
};
